import { Component, OnInit } from "@angular/core";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { AppService } from "src/app/app.service";
import { environment } from "src/environments/environment";
import * as CryptoJS from "crypto-js";

@Component({
  selector: "app-add-profile",
  templateUrl: "./add-profile.component.html",
  styleUrls: ["./add-profile.component.css"],
})
export class AddProfileComponent implements OnInit {
  colors = ["green", "red", "yellow", "purple"];
  randColor = this.colors[Math.floor(Math.random() * this.colors.length)];
  model: any = { status: "no" };
  isLoading = false;
  btnDisable = false;
  userInfo: any;
  constructor(
    private service: AppService,
    private toastr: ToastrService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.model.color = this.randColor;
    const encryptedData = localStorage.getItem(environment.localStorageKey);
    if (encryptedData) {
      this.userInfo = JSON.parse(
        CryptoJS.AES.decrypt(encryptedData, environment.secretkey).toString(
          CryptoJS.enc.Utf8
        )
      );
    } else {
      this.router.navigate(["/"]);
    }
  }
  onChange(ob: MatSlideToggleChange) {
    if (ob.checked == true) {
      this.model.status = "yes";
    } else {
      this.model.status = "no";
    }
  }

  onSubmit(form: any) {
    if (form.valid) {
      this.btnDisable = true;
      this.isLoading = true;
      this.service.addProfile(this.model).subscribe(
        (res: any) => {
          this.btnDisable = false;
          this.isLoading = false;
          this.userInfo.people_profile.push({
            id: res.id,
            user_id: res.user_id,
            name: res.name,
            status: res.status,
            child_status: res.child_status,
            color: res.color,
          });
          const encryptData = CryptoJS.AES.encrypt(
            JSON.stringify(this.userInfo),
            environment.secretkey
          ).toString();
          localStorage.setItem(environment.localStorageKey, encryptData);
          this.toastr.success(res.message, "Success!", {
            closeButton: true,
          });
          this.router.navigate(["/manage-profile/watch"]);
        },
        (err) => {
          this.btnDisable = false;
          this.isLoading = false;
          this.toastr.error(err.error.message, "OOPS!", {
            closeButton: true,
          });
        }
      );
    }
  }
}
